import axios from 'axios';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class CompareList {
    constructor() {
        /**
         * Обёртка блока со сравнением
         */
        this.wrapper = null;

        /**
         * Адрес запросов
         * @type {string}
         */
        this.action = '';

        /**
         * Обёртка для списка квартир
         */
        this.contentWrapper = null;

        /**
         * Массив с ID элементов в сравнении
         * @type {array}
         */
        this.compare = [];

        /**
         * Чекбокс различия
         */
        this.checkboxDifference = null;

        /**
         * Кнопка очистить список
         */
        this.clearButton = null;

        /**
         * Кнопки удалить из сравнения
         */
        this.clearButtons = null;

        /**
         * Скрывать/не скрывать забронированные квартиры
         * @type {boolean}
         */
        this.isHideLocked = false;

        /**
         * Класс который добавляется при подгрузке
         * @type {string}
         */
        this.loadingClass = 'is-loading';

        /**
         * Тип запроса
         * @type {string}
         */
        this.requestType = '';

        /**
         * Враппер контента результатов
         * * @type {string}
         */
        this.contentResults = null;

        this.processClass = 'is-process';
        this.activeClass = 'is-active';

        this.parent = null;
        this.estateType = 'flats';
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;
        this._getElements();
        this._toggleLoading();
        this._getDataJson();
        this._bindEvents();
        this._addCounterElements();
        this._subscribers();
        this._heightRows();
    }

    /**
     * Получение дом-элементов
     * @private
     */
    _getElements() {
        this.action = this.wrapper.getAttribute('action') || 'tests/compare/compare.json';
        this.filter = this.wrapper.querySelector('.j-compare-filter');
        // Враппер результата
        this.resultWrapper = this.wrapper.querySelector('.j-compare-result-wrapper');
        // Враппер контента результатов
        this.contentWrapper = this.wrapper.querySelector('.j-compare__result');

        if (this.contentWrapper) {
            // Слайдеры
            this.sliders = Array.from(this.contentWrapper.querySelectorAll('.slider-swiper'));
            // Заголовок количества квартир в сравнении
            this.resultCounterTitle = this.filter.querySelector('.j-compare__top-counter');
            // Чекбокс различия
            this.checkboxDifference = this.filter.querySelector('.j-compare__filter-difference input');
            // Кнопка очистить список
            this.clearButton = this.wrapper.querySelector('.j-compare__top-clear');
            // Уведомление о попытке полностью очистить список
            this.clearTooltip = this.wrapper?.querySelector('.j-compare__clear-tooltip');
            // Кнопки удаления из сравнения
            this.clearButtons = Array.from(this.contentWrapper.querySelectorAll('.j-compare__item-clear'));
            // Элементы сравнения
            this.compareItems = Array.from(this.contentWrapper.querySelectorAll('.j-compare__result-item'));
        }
    }

    /**
     * Навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        this.checkboxDifference?.addEventListener('change', () => {
            if (this.checkboxDifference.checked) {
                this._hideSameValues();
            } else {
                this._showSameValues();
            }
        });

        if (this.clearButtons) {
            this.clearButtons.forEach((button) => {
                button.addEventListener('click', this._removeCompareItem.bind(this));
            });
        }

        if (this.clearButton && this.clearTooltip) {
            // this.clearButton.addEventListener('click', this._removeAllCompareItems.bind(this));
            this.clearButton.addEventListener('click', this._showClearAllTooltip.bind(this));
        }
    }

    _initClearTooltip() {
        // Отказ от очистики списка
        this.clearCancel = this.clearTooltip?.querySelector('.j-compare__clear-cancel');
        // Подтверждение очистки списка
        this.clearApproved = this.clearTooltip?.querySelector('.j-compare__clear-approved');
    }

    /**
     * Заменяет контент
     * @param {Node} element - элемент, контент которого будет заменен
     * @param {string} html - новый контент
     * private
     */
    _replaceContent(element, html) {
        Utils.clearHtml(element);
        Utils.insetContent(element, html);
    }

    /**
     * Переключает лоадер вкл/выкл
     * @private
     */
    _toggleLoading() {
        this.resultWrapper.classList.remove('is-loading');
    }

    _getDataJson() {
        const dataAttributeJson = this.wrapper.dataset.json;

        if (!dataAttributeJson.length) {
            this._showNothing();

            return;
        }

        const dataJson = JSON.parse(Utils.fromBase64(dataAttributeJson));

        this.quantity = dataJson.data.quantity;

        if (this.quantity === 0) {
            this.clearButton.classList.add('is-hidden');
        }

        this.compareList = dataJson.data.compareList;

        if (this.compareList.length === 1) {
            this.checkboxDifference.disabled = true;
        }
    }

    // Скрывает одинаковые параметры квартир
    _hideSameValues() {
        const dataAttributeJson = this.wrapper.dataset.json;

        if (!dataAttributeJson.length) {
            return;
        }
        const compareDataJson = JSON.parse(Utils.fromBase64(dataAttributeJson));
        const compareLines = Array.from(this.contentWrapper.querySelectorAll('.compare__item-line'));
        const diffArr = [];

        let x = {};

        compareDataJson.data.compareList.forEach((item, index) => {
            // Подготовка эталона
            if (index === 0) {
                x = Object.assign(item);

                return;
            }

            Object.keys(item).forEach((key) => {
                if (!diffArr.includes(key) && x[key] !== item[key]) {
                    diffArr.push(key);
                }
            });
        });

        compareLines.forEach((item) => {
            if (!diffArr.includes(item.dataset.line) &&
                item.dataset.line !== 'order' &&
                !item.classList.contains('compare__item-features-title')
            ) {
                item.style.display = 'none';
            }
        });

        this._titlesHidden();
    }

    _titlesHidden() {
        // eslint-disable-next-line
        const compareLines = Array.from(this.contentWrapper.querySelectorAll('.compare__item-line:not(.compare__item-features-title)'));
        const compareTitles = Array.from(this.contentWrapper.querySelectorAll('.compare__item-features-title'));

        compareTitles.forEach((item) => {
            item.style.display = 'none';
        });

        compareLines.forEach((item) => {
            if (item.dataset.type && item.style.display !== 'none') {
                compareTitles.forEach((itemTitle) => {
                    if (itemTitle.dataset.type === item.dataset.type) {
                        itemTitle.style.display = 'flex';
                    }
                });
            }
        });
    }

    // Показывает все параметры квартир
    _showSameValues() {
        const compareLines = Array.from(this.contentWrapper.querySelectorAll('.compare__item-line'));

        compareLines.forEach((item) => {
            item.style.display = 'flex';
        });
    }

    // Удаляет элемент из ноды и обновляет слайдер
    _removeCompareItem(event) {
        const button = event.currentTarget;
        const id = button.dataset.id;
        const parent = button.closest('.j-compare__result-item');

        event.preventDefault();
        event.stopImmediatePropagation();
        this._removeCompare(id, parent);
        observer.publish('compareSlider:removeSlide', parent);
    }

    _showClearAllTooltip() {
        this._initClearTooltip();
        this.clearTooltip.classList.add('is-active');
        this.clearCancel.addEventListener('click', this._hideClearAllTooltip.bind(this));
        this.clearApproved.addEventListener('click', this._removeAllCompareItems.bind(this));
    }

    _hideClearAllTooltip() {
        this.clearCancel?.replaceWith(this.clearCancel.cloneNode(true));
        this.clearApproved?.replaceWith(this.clearApproved.cloneNode(true));
        // Прячем тултип
        this.clearTooltip.classList.remove('is-active');
    }

    // Удаляет все элементы из ноды
    _removeAllCompareItems(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this._removeAllCompare();
        this._showNothing();
        this._hideClearAllTooltip();
    }

    /**
     * Удаляем id элемента из локального хранилища
     * @param {string} id - id элемента
     * @param {string} parent - parent элемента
     */
    _removeCompare(id, parent) {
        this.requestType = 'removeCompare';

        if (parent.classList.contains('j-compare-flat-commerce')) {
            this.estateType = 'commerces';
        }

        const compareData = new FormData();

        compareData.append('requestType', this.requestType);
        compareData.append('estateType', this.estateType);
        compareData.append('id', id);

        axios.post(this.action, compareData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.data = response.data.data;

                    if (this.data.compare === 1) {
                        this.checkboxDifference.disabled = true;
                    }

                    observer.publish('compare:update');
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /**
     * Удаляем все id элементов из локального хранилища
     */
    _removeAllCompare() {
        const compareData = new FormData();

        this.requestType = 'removeAllCompares';
        compareData.append('requestType', this.requestType);

        axios.post(this.action, compareData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.data = response.data.data;
                    this.clearButton.classList.add('is-hidden');
                    observer.publish('compare:update');
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    _showNothing() {
        const nothingBlock = document.querySelector('.j-compare-result__nothing');
        const resultBlock = document.querySelector('.j-compare-result__results');

        Utils.hide(resultBlock);
        Utils.show(nothingBlock);
    }

    // Добавляет счётчик количества элементов
    _addCounterElements() {
        if (this.sliders) {
            this.sliders.forEach((sliderItem) => {
                const headerCounter = document.querySelector('.j-compare__top-counter');
                const compareItems = Array.from(sliderItem.querySelectorAll('.j-compare__result-item'));

                if (!compareItems.length) {
                    this._showNothing();

                    return;
                }

                headerCounter.innerHTML = this.quantity ? this.quantity : '';

                compareItems.forEach((item, index) => {
                    const compareCounter = item.querySelector('.j-compare-counter');

                    if (compareCounter) {
                        const compareCounterAll = compareCounter.querySelector('.j-compare-counter-all');
                        const compareCounterElem = compareCounter.querySelector('.j-compare-counter-elem');
                        const indexItem = index + 1 < 9 ? `0${index + 1}` : index + 1;
                        const count = compareItems.length < 9 ? `0${compareItems.length}` : compareItems.length;

                        Utils.clearHtml(compareCounterAll);
                        compareCounterAll.innerHTML = count;

                        Utils.clearHtml(compareCounterElem);
                        compareCounterElem.innerHTML = indexItem;
                    }
                });
            });
        }
    }

    /**
     * Подписка
     * @private
     */
    _subscribers() {
        observer.subscribe('compareSlider:removeSlide', (item) => {
            const compareItems = Array.from(this.contentWrapper.querySelectorAll('.j-compare__result-item'));

            const itemIndex = compareItems.indexOf(item);
            const secondSliderItems = compareItems.length / 2;
            const index = itemIndex >= secondSliderItems ? itemIndex - secondSliderItems : itemIndex;
            const firstSliderItem = compareItems[index];
            const secondSliderItem = compareItems[secondSliderItems + index];

            Utils.removeElement(secondSliderItem);
            Utils.removeElement(firstSliderItem);
            this._addCounterElements();

            observer.publish('compareSlider:refresh');
        });
    }

    // Редактирует высоту строчек таблицы КОСТЫЛЬ!!!!!
    _heightRows() {
        if (!this.contentWrapper) {
            return;
        }
        // eslint-disable-next-line
        const compareNameItems = Array.from(this.contentWrapper.querySelectorAll('.j-compare__result-names .compare__item-line'));

        if (compareNameItems) {
            compareNameItems.forEach((itemName) => {
                const dataLine = itemName.dataset.line;
                // eslint-disable-next-line
                const compareResultItemLines = Array.from(this.contentWrapper.querySelectorAll(`.j-compare__result-item .compare__item-line[data-line=${dataLine}]`));

                compareResultItemLines.forEach((itemResult) => {
                    if (itemResult.offsetHeight !== itemName.offsetHeight) {
                        itemResult.style.height = `${itemName.offsetHeight}px`;
                    }
                });
            });
        }
    }
}

export default CompareList;
